<template>
  <div class="funcionario-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
      :on-close="onCancel"
    >
      <field-group-form
        :group-label="(showEdit ? 'Editar ' : '') + 'Cargo / Função'"
        class="pb-4"
      >
        <v-row v-if="!showEdit">
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <v-layout class="mb-1" justify-end>
              <v-chip
                small
                close
                color="success"
                :style="!getCargo().new ? 'visibility: hidden' : ''"
                @click:close="onCancelNew('newCargo')"
                >novo</v-chip
              >
            </v-layout>
            <validation-provider
              v-slot="{ errors }"
              name="cargo"
              rules="required"
            >
              <v-autocomplete
                v-model="cargo"
                @keyup.native="(v) => onSearch('cargoSearch', v)"
                item-text="nome"
                item-value="id"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :items="cargosFuncoes.map((e) => e.cargo)"
                :label="$t('Cargo')"
                :error-messages="errors"
                no-data-text="nenhum item encontrado"
                :loading="fetchListStatus"
                :persistent-placeholder="fetchListStatus"
                :placeholder="fetchListStatus ? 'carregando...' : null"
              >
                <template #no-data>
                  <v-list-item v-if="cargoSearch">
                    <v-list-item-title>
                      <v-btn
                        text
                        x-small
                        elevation="0"
                        color="success"
                        @click="onAddNew('newCargo')"
                      >
                        <v-icon x-small>mdi-plus</v-icon>
                        <small class="pl-1" v-if="newCargo">
                          <b>atualizar como novo cargo</b>
                        </small>
                        <small v-else class="pl-1">
                          <b>incluir como novo cargo</b>
                        </small>
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </validation-provider>
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <v-layout class="mb-1" justify-end>
              <v-chip
                small
                close
                color="success"
                :style="!getFuncao().new ? 'visibility: hidden' : ''"
                @click:close="onCancelNew('newFuncao')"
                >novo</v-chip
              >
            </v-layout>
            <validation-provider
              v-slot="{ errors }"
              name="funcao"
              rules="required"
            >
              <v-autocomplete
                v-model="funcao"
                @keyup="(v) => onSearch('funcaoSearch', v)"
                item-text="nome"
                item-value="id"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :items="
                  cargosFuncoes
                    .map((e) => (e.idCargo === cargo ? e.funcao : null))
                    .filter((e) => e)
                "
                :label="$t('Funcao')"
                :error-messages="errors"
                no-data-text="nenhum item encontrado"
                :loading="fetchListStatus"
                :persistent-placeholder="fetchListStatus"
                :placeholder="fetchListStatus ? 'carregando...' : null"
              >
                <template #no-data>
                  <v-list-item v-if="funcaoSearch">
                    <v-list-item-title>
                      <v-btn
                        text
                        x-small
                        elevation="0"
                        color="success"
                        @click="onAddNew('newFuncao')"
                      >
                        <v-icon x-small>mdi-plus</v-icon>
                        <small class="pl-1" v-if="newFuncao">
                          <b>atualizar como nova função</b>
                        </small>
                        <small v-else class="pl-1">
                          <b>incluir como nova função</b>
                        </small>
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="6">
            <validation-provider
              v-slot="{ errors }"
              name="cargoNome"
              rules="required"
            >
              <v-text-field
                v-model="edited.cargoNome"
                dense
                outlined
                label="Cargo"
                :value="getCargo().nome"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col cols="6">
            <validation-provider
              v-slot="{ errors }"
              name="funcaoNome"
              rules="required"
            >
              <v-text-field
                v-model="edited.funcaoNome"
                dense
                outlined
                label="Função"
                :value="getFuncao().nome"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <div class="mt-6" v-if="!fetchListStatus && !newCargo && !newFuncao">
          <v-btn
            v-if="!showEdit"
            text
            x-small
            elevation="0"
            color="blue"
            @click="onEditCargoFuncao"
          >
            <v-icon x-small>mdi-pencil</v-icon>
            <small class="pl-1">editar cargo/função</small>
          </v-btn>
          <v-btn
            v-else
            text
            x-small
            elevation="0"
            color="red"
            @click="onCancelEditCargoFuncao"
          >
            <v-icon x-small>mdi-close</v-icon>
            <small class="pl-1">cancelar edição</small>
          </v-btn>
        </div>
      </field-group-form>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { extend, ValidationProvider } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { updateData } from "@/services";
export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm, ValidationProvider },
  data: () => ({
    cargosFuncoes: [],
    cargo: null,
    funcao: null,
    edited: { cargoNome: null, funcaoNome: null },
    showEdit: false,
    newCargo: false,
    newFuncao: false,
    fields: {},
    funcaoSearch: null,
    cargoSearch: null,
    fetchListStatus: false,
  }),
  watch: {
    "store.showModalDataForm"(nextValue) {
      if (nextValue) {
        this.fields = {};
        this.edited = { cargoNome: null, funcaoNome: null };
        this.showEdit = false;
        this.newCargo = false;
        this.newFuncao = false;
        this.funcaoSearch = null;
        this.cargoSearch = null;

        this.fetchListStatus = true;
        this.getListCargosFuncoes(() => {
          this.cargo = this.data.empCarFun.idCargo;
          this.funcao = this.data.empCarFun.idFuncao;
        });
      } else {
        this.cargo = null;
        this.funcao = null;
        this.cleanOnCloseCargosFuncoes();
      }
    },
  },
  computed: {
    store() {
      return this.$store.state;
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);

    extend("required", {
      ...required,
      message: this.$t("obrigatorio"),
    });

    this.getListCargosFuncoes();
  },
  methods: {
    onEditCargoFuncao() {
      this.showEdit = true;
      this.edited.cargoNome = this.data.empCarFun.cargo.nome;
      this.edited.funcaoNome = this.data.empCarFun.funcao.nome;
    },
    onCancelEditCargoFuncao() {
      this.showEdit = false;
      this.edited = { cargoNome: null, funcaoNome: null };
      this.editConfim = false;
    },
    onSearch(name, v) {
      this[name] = v.target.value;
    },
    onCancel(form) {
      form.reset();
    },
    onSave() {
      let empCarFun = {};

      empCarFun.idEmpresa = this.data.empCarFun.idEmpresa;
      empCarFun.empresa = { id: empCarFun.idEmpresa };

      empCarFun.cargo = this.getCargo();

      empCarFun.funcao = this.getFuncao();

      empCarFun.idCargo = empCarFun.cargo?.id;
      empCarFun.idFuncao = empCarFun.funcao?.id;

      empCarFun = this.cleanCargosFuncoes(empCarFun);

      if (this.showEdit) {
        empCarFun.cargo.nome = this.edited.cargoNome;
        empCarFun.funcao.nome = this.edited.funcaoNome;
      }

      updateData(
        this,
        "tagFuncionario",
        { ...this.data, ...{ empCarFun } },
        (empCarFun) => {
          empCarFun.empresa = this.data.empCarFun.empresa;
          this.$store.commit("tagFuncionario/setData", {
            ...this.data,
            ...{ empCarFun },
          });
        }
      );
    },
    onAddNew(type) {
      let empCarFun = {};

      empCarFun.idEmpresa = this.data.empCarFun.idEmpresa;
      empCarFun.empresa = this.data.empCarFun.empresa;

      if (type === "newCargo") {
        empCarFun.idCargo = "null_" + this.cargoSearch.replace(/\s/g, "_");
        empCarFun.cargo = {
          id: empCarFun.idCargo,
          nome: this.cargoSearch,
          new: true,
        };
        if (this.newCargo) {
          const index = this.cargosFuncoes.indexOf(empCarFun);
          this.cargosFuncoes.splice(index, 1, empCarFun);
        } else {
          this.cargosFuncoes.push(empCarFun);
        }
        this.newCargo = true;
      } else if (type === "newFuncao") {
        this.newFuncao = true;

        empCarFun = this.cargosFuncoes.find(
          (e) => e.cargo.nome === this.cargoSearch
        );

        // caso não encontrar pelo cargoSearch é porque o usuario
        // esta criando apenas uma nova funcao, no mesmo cargo existe
        if (!empCarFun) {
          empCarFun = this.cargosFuncoes.find((e) => e.cargo.id === this.cargo);
        }

        empCarFun.idFuncao = "null_" + this.funcaoSearch.replace(/\s/g, "_");

        empCarFun.funcao = {
          id: empCarFun.idFuncao,
          nome: this.funcaoSearch,
          new: true,
        };

        const index = this.cargosFuncoes.indexOf(empCarFun);
        this.cargosFuncoes.splice(index, 1, empCarFun);
      }
    },
    onCancelNew(type) {
      if (type === "newCargo") {
        this.cargosFuncoes = this.cargosFuncoes.filter(
          (e) => e.cargo.nome !== this.cargoSearch
        );
        this.newCargo = false;
        this.cargo = null;
        this.newFuncao = false;
        this.funcao = null;
        this.cargoSearch = null;
        this.funcaoSearch = null;
      } else if (type === "newFuncao") {
        const find =
          this.cargosFuncoes.find((e) => e.funcao.nome === this.funcaoSearch) ||
          {};

        delete find.funcao;
        delete find.idFuncao;

        this.newFuncao = false;
        this.funcao = null;
        this.funcaoSearch = null;
      }
    },
    getListCargosFuncoes(callback) {
      this.fetchListStatus = true;
      this.$store.dispatch("tagFuncionario/getCargosFuncoes", {
        idEmpresa: this.data.empCarFun.idEmpresa,
        token: this.$store.state.auth.user.token,
        callbackSuccess: (result) => {
          this.cargosFuncoes = result;
          callback && callback();
          this.fetchListStatus = false;
        },
        callbackError: () => (this.fetchListStatus = false),
      });
    },
    getCargo() {
      const find = this.cargosFuncoes.find((e) => e.cargo?.id === this.cargo);
      return find ? find.cargo : {};
    },
    getFuncao() {
      const find = this.cargosFuncoes.find(
        (e) => e.funcao?.id === this.funcao && e.cargo?.id === this.cargo
      );
      return find ? find.funcao : {};
    },
    cleanCargosFuncoes(empCarFun) {
      if (String(empCarFun.cargo?.id).includes("null_")) {
        delete empCarFun.idCargo;
        delete empCarFun.cargo.id;
      }

      if (String(empCarFun.funcao?.id).includes("null_")) {
        delete empCarFun.idFuncao;
        delete empCarFun.funcao.id;
      }

      return empCarFun;
    },
    cleanOnCloseCargosFuncoes() {
      this.cargosFuncoes.map((empCarFun, i) => {
        if (String(empCarFun.cargo?.id).includes("null_")) {
          this.cargosFuncoes.splice(i, 1);
        }
      });
    },
  },
};
</script>

<style scoped></style>
